import { gql } from "@grandvisionhq/graphql";
const discount = gql`
  fragment DiscountFragment on Discount {
    id
    isActive
    key
    name {
      locale
      value
      __typename
    }
    description {
      locale
      value
    }
    type
    value {
      centAmount
      percentage
      scale
      type
      __typename
    }
    validFrom
    validUntil
    __typename
  }
`;
export {
  discount
};
//# sourceMappingURL=discount.js.map
